/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'tools.ozone.server.getConfig'

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  appview: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<ServiceConfig>((() => serviceConfig) as any),
  ),
  pds: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<ServiceConfig>((() => serviceConfig) as any),
  ),
  blobDivert: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<ServiceConfig>((() => serviceConfig) as any),
  ),
  chat: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<ServiceConfig>((() => serviceConfig) as any),
  ),
  viewer: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<ViewerConfig>((() => viewerConfig) as any),
  ),
  verifierDid: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'did' }),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get details about ozone's server configuration. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

export const $lxm = $nsid

type ServiceConfig = {
  $type?: 'tools.ozone.server.getConfig#serviceConfig'
  url?: l.UriString
}

export type { ServiceConfig }

const serviceConfig = /*#__PURE__*/ l.typedObject<ServiceConfig>(
  $nsid,
  'serviceConfig',
  /*#__PURE__*/ l.object({
    url: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'uri' })),
  }),
)

export { serviceConfig }

type ViewerConfig = {
  $type?: 'tools.ozone.server.getConfig#viewerConfig'
  role?:
    | 'tools.ozone.team.defs#roleAdmin'
    | 'tools.ozone.team.defs#roleModerator'
    | 'tools.ozone.team.defs#roleTriage'
    | 'tools.ozone.team.defs#roleVerifier'
    | l.UnknownString
}

export type { ViewerConfig }

const viewerConfig = /*#__PURE__*/ l.typedObject<ViewerConfig>(
  $nsid,
  'viewerConfig',
  /*#__PURE__*/ l.object({
    role: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{
        knownValues: [
          'tools.ozone.team.defs#roleAdmin',
          'tools.ozone.team.defs#roleModerator',
          'tools.ozone.team.defs#roleTriage',
          'tools.ozone.team.defs#roleVerifier',
        ]
      }>(),
    ),
  }),
)

export { viewerConfig }
